import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../EnvImpairment/envImpairment.module.scss'
import metadata from './StorageTankInfoComponent.metadata.json5';

import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function StorageTankInfoComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('StorageTankInfoComponent');

    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        totNumOfTan3: {
            value: modelVM.value.numOfAboGroStoTan1 + modelVM.value.numOfUndStoTan2
        },
        ifNoProDet5: {
            visible: !_.isUndefined(modelVM.value.werAllTanNewAtIns4) && !modelVM.value.werAllTanNewAtIns4
        },
        ifYesPleProDet7: {
            visible: !_.isUndefined(modelVM.value.isTheAHisOfLeaOr6) && modelVM.value.isTheAHisOfLeaOr6
        },
        datOfLatOcc8: {
            visible: !_.isUndefined(modelVM.value.isTheAHisOfLeaOr6) && modelVM.value.isTheAHisOfLeaOr6
        },
        estCosForAllRep9: {
            visible: !_.isUndefined(modelVM.value.isTheAHisOfLeaOr6) && modelVM.value.isTheAHisOfLeaOr6
        },
        havAnyRepOrUpgIncRel11: {
            visible: !_.isUndefined(modelVM.value.detOfUpgChaMadToThe10) && modelVM.value.detOfUpgChaMadToThe10 !== 'None'
        },
        ifYesWhyWerTheRepOr12: {
            visible: !_.isUndefined(modelVM.value.havAnyRepOrUpgIncRel11) && modelVM.value.havAnyRepOrUpgIncRel11
        },
        ifYesPleProDetWhy14: {
            visible: !_.isUndefined(modelVM.value.werAnyTanEveRemOrClo13) && modelVM.value.werAnyTanEveRemOrClo13
        },
        ifYesPleProSpeDetAs20: {
            visible: !_.isUndefined(modelVM.value.areTheAnyOilWatSepOn19) && modelVM.value.areTheAnyOilWatSepOn19
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

StorageTankInfoComponent.propTypes = wizardProps;
export default withRouter(StorageTankInfoComponent);
